<template>
   <div class="error_wrap">
    <div class="container-fluid-xl">
    <div class="error_vipps text-center">
       <img src="~@/assets/err_vipps.webp" alt="success_order">
       <p>  {{get_local_string.string_112}} </p>
         <b-button tag="router-link" to="/meny" type="is-success">{{get_local_string.string_106}}</b-button>
    </div>
   </div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name:'error_vipps_order',
     computed:{
        ...mapGetters({
        get_local_string:'get_local_string'
        })
    },
    mounted(){
        console.log('mount page');
    },
}
</script>
<style lang="scss" scoped>
.error_vipps{
    padding-top:120px;
    padding-bottom:30px;
    position:relative;
    z-index:2;
    min-height:calc(100vh - 300px);
    img{
        width:400px;
        margin-bottom:20px;
    }
    p{
        font-size:14px;
        font-weight:600;
        color:#000;
        margin-bottom:15px;
    }
}
</style>